<template>
    <el-dialog
        class="import"
        :visible.sync="importVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        :modal-append-to-body="false"
        append-to-body
        width="800px"
        :title="title ? title : '批量导入'"
    >
        <el-alert type="warning" :closable="false">
            <template slot="title">
                <div style="display: flex; text-align: left; line-height: 1.6">
                    Import Rule Description:
                </div>
                <div style="display: flex; text-align: left; line-height: 1.6">
                    File format:
                    <br />XLS or xlsx (i.e. excel format), and the file size
                    shall not be greater than 5M.
                </div>
            </template>
        </el-alert>
        <!-- <div class="bulkText">Please select the excel file to import</div> -->
        <div class="radio-template" v-if="needChioceTemplate">
            <el-radio-group v-model="template">
                <el-radio :label="0">DBK</el-radio>
                <el-radio :label="1">General</el-radio>
                <el-radio :label="2">General 2</el-radio>
            </el-radio-group>
        </div>
        <el-upload
            style="display: flex; margin: 12px 0"
            :limit="1"
            class="upload-demo"
            ref="upload"
            action
            :file-list="fileList"
            :http-request="uploadFile"
            :on-remove="handleRemove"
            :accept="accept"
            :auto-upload="false"
        >
            <el-button slot="trigger" size="small" type="primary"
                >Select File</el-button
            >
            <el-button
                size="small"
                style="margin-left: 12px"
                type="success"
                @click="submitUpload"
                >Upload</el-button
            >
        </el-upload>
        <a
            v-if="this.temSrc"
            @click="download(wwwUrl,temSrc,template)"
            style="color: blue; font-size: 14px; display: flex; line-height: 2"
            >Click to download the sample file</a
        >
        <ul class="condition" v-if="success_num > 0 || failure_num > 0">
            <li>Import Situation</li>
            <li style="color: #67c23a">Success: {{ success_num }}</li>
            <li style="color: #f56c6c">Fail: {{ failure_num }}</li>
            <li v-for="item in errArray" :key="item">
                {{ item }}
            </li>
        </ul>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="importVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            success_num: "",
            failure_num: "",
            errArray: [],
            template: 0,
        };
    },
    methods: {
        submitUpload() {
            this.$refs.upload.submit();
        },
        download(wwwUrl,temSrc, template){
            window.open(wwwUrl + (temSrc instanceof Array ? temSrc[template] : temSrc));
        },
        // 批量上传
        uploadFile(file) {
            let formData = new FormData();
            formData.append("file", file.file);
            cmofferApi[this.methodName instanceof Array ? this.methodName[this.template] : this.methodName](formData, "post", "", {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((res) => {
                if (res) {
                    if (res.data.errors.length == 0) {
                        this.$parent[this.parentFuncName]();
                        // this.$message.success("上传成功");
                    } else if (res.data.errors.length > 0) {
                        // this.$message.error("数据有误");
                    } else if (res.code == 422) {
                        // this.$message.error("上传失败");
                        formData.delete("files");
                        this.$message.error(res.msg);
                    }
                    this.success_num = res.data.success_num;
                    this.failure_num = res.data.failure_num;
                    this.errArray = res.data.errors;
                }
            });
        },
        // 弹窗关闭
        closeDialog() {
            this.success_num = "";
            this.failure_num = "";
            this.errArray = [];
            this.$refs.upload.clearFiles();
            this.$emit("update:importVisible", false);
        },
        handleRemove(file, fileList) {
            this.$refs["upload"].clearFiles();
            this.success_num = "";
            this.failure_num = "";
            this.errArray = [];
        },
    },
    props: {
        importVisible: Boolean,
        methodName: [String, Array],
        parentFuncName: String,
        temSrc: [String, Array],
        title: String,
        accept: {
            type: String,
            default: ".xls,.xlsx",
        },
        needChioceTemplate:{
            type: Boolean,
            default: false,
        }
    },
    computed: {
        wwwUrl() {
            return this.$store.state.index.wwwUrl;
        },
    },
};
</script>
<style lang="scss">
.import {
    .bulkText {
        margin-top: 12px;
        text-align: left;
    }
    .condition {
        border-top: 1px solid #ddd;
        width: 100%;
        li {
            text-align: left;
            line-height: 2;
        }
    }
    .radio-template{
        margin: 12px 0 0 0;
        .el-radio-group{
            .el-radio__label{
                font-size: 12px;
            }
        }
    }
}
</style>
